import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Price from 'components/Common/Price'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  background: #e7e7ea;
  border: 1px solid #e7e7ea;
  border-radius: 8px;
  overflow: hidden;
`

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  padding: 12px 16px;
  gap: 4px;
  background: #fff;
`

const SpecLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  font: var(--typography-14-20-regular);
  color: #121432;

  ${props => {
    if (props.weight === 2) {
      return `font-weight: 600;`
    }

    if (props.weight === 0) {
      return `color: #717284;`
    }
  }}
`

const Table = ({ values, koef }) => {
  const { t } = useTranslation()
  const multiplied = value => Math.round((value || 0) * koef * 100) / 100
  const zero = nutrition =>
    t('wine.view.nutritionDeclaration.param', {
      param: t(nutrition)?.toLowerCase(),
    })

  return (
    <Wrapper>
      <Section>
        <SpecLine weight={2}>
          <span>{t('wine.view.nutritionDeclaration.energy')}</span>
          <span>
            <span>
              {values.energyKCalApproximate ? '<' : ''}
              <Price value={multiplied(values.energyKCal)} /> kcal
            </span>{' '}
            /{' '}
            <span>
              <Price value={multiplied(values.energyKJ)} /> kJ
            </span>
          </span>
        </SpecLine>
      </Section>

      <Section>
        <SpecLine weight={1}>
          {values.fat ? (
            <>
              <span>{t('wine.view.nutritionDeclaration.fat')}</span>
              <span>
                {values.fatApproximate ? '<' : ''}
                <Price value={multiplied(values.fat)} /> g
              </span>
            </>
          ) : (
            zero('wine.view.nutritionDeclaration.fat')
          )}
        </SpecLine>

        {(values.saturates || values.fat) &&
          (values.saturates ? (
            <>
              <SpecLine weight={0}>
                <span>{t('wine.view.nutritionDeclaration.ofWhich')}</span>
              </SpecLine>

              <SpecLine weight={0}>
                <span>{t('wine.view.nutritionDeclaration.saturates')}</span>
                <span>
                  {values.saturatesApproximate ? '<' : ''}
                  <Price value={multiplied(values.saturates)} /> g
                </span>
              </SpecLine>
            </>
          ) : (
            <SpecLine weight={0}>
              <span>{zero('wine.view.nutritionDeclaration.saturates')}</span>
            </SpecLine>
          ))}
      </Section>

      <Section>
        <SpecLine weight={1}>
          {values.carbohydrate ? (
            <>
              <span>{t('wine.view.nutritionDeclaration.carbohydrate')}</span>
              <span>
                {values.carbohydrateApproximate ? '<' : ''}
                <Price value={multiplied(values.carbohydrate)} /> g
              </span>
            </>
          ) : (
            zero('wine.view.nutritionDeclaration.carbohydrate')
          )}
        </SpecLine>

        {(values.sugars || values.carbohydrate) &&
          (values.sugars ? (
            <>
              <SpecLine weight={0}>
                <span>{t('wine.view.nutritionDeclaration.ofWhich')}</span>
              </SpecLine>

              <SpecLine weight={0}>
                <span>{t('wine.view.nutritionDeclaration.sugars')}</span>
                <span>
                  {values.sugarsApproximate ? '<' : ''}
                  <Price value={multiplied(values.sugars)} /> g
                </span>
              </SpecLine>
            </>
          ) : (
            <SpecLine weight={0}>
              <span>{zero('wine.view.nutritionDeclaration.sugars')}</span>
            </SpecLine>
          ))}
      </Section>

      <Section>
        <SpecLine weight={1}>
          {values.protein ? (
            <>
              <span>{t('wine.view.nutritionDeclaration.protein')}</span>
              <span>
                {values.proteinApproximate ? '<' : ''}
                <Price value={multiplied(values.protein)} /> g
              </span>
            </>
          ) : (
            zero('wine.view.nutritionDeclaration.protein')
          )}
        </SpecLine>
      </Section>

      <Section>
        <SpecLine weight={1}>
          {values.salt ? (
            <>
              <span>{t('wine.view.nutritionDeclaration.salt')}</span>
              <span>
                {values.saltApproximate ? '<' : ''}
                <Price value={multiplied(values.salt)} /> g
              </span>
            </>
          ) : (
            zero('wine.view.nutritionDeclaration.salt')
          )}
        </SpecLine>
      </Section>
    </Wrapper>
  )
}

export default Table
